import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";

interface OverallProgressProps {
  averageScore: number;
}

export const OverallProgress = ({ averageScore }: OverallProgressProps) => {
  const roundedScore = Math.round(averageScore);
  
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Overall Progress</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          <div className="flex justify-between text-sm">
            <span>Average Score</span>
            <span className="font-medium">{roundedScore}%</span>
          </div>
          <Progress value={roundedScore} className="h-2" />
        </div>
      </CardContent>
    </Card>
  );
};